import { useCallback } from 'react';

import { UPGRADE_POPUP } from '../types';
import { usePopups } from '../services';
import { PERFORMANCE_CHANNELS } from 'src/data/performance';
import { getPerformanceFeatureLimitsFromChannel } from 'src/data/featureLimits';

export const useUpgradePopup = () => {
  const popups = usePopups();

  return useCallback(
    (feature) => {
      const isPerformanceChannel = PERFORMANCE_CHANNELS.includes(feature);

      popups.openPopup(UPGRADE_POPUP, {
        feature: isPerformanceChannel ? getPerformanceFeatureLimitsFromChannel(feature) : feature,
        isPerformanceChannel,
        onClose: () => {
          popups.closePopup(UPGRADE_POPUP);
        },
      });
    },
    [popups]
  );
};
